import getAxiosInstance from "../../../common/mhiAxios";
import { Clip, Folder, Footage, Timeline, UploadTimelineInfo } from "../../models/Timeline";

export default {
    // 未編集のフッテージ一覧取得
    getUneditedFootages(): Promise<any> {
        return getAxiosInstance()
            .get(`/api/getUneditedFootages`)
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },

    // タイムライン取得
    getTimelines(statusList: string[]): Promise<any> {
        return getAxiosInstance()
            .post("/api/getTimelines", { statusList: statusList })
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },

    // タイムラインのアップロード
    UploadTimeline(timeline: UploadTimelineInfo): Promise<any> {
        const params = new FormData();
        params.append(
            "imageFile",
            timeline.imageFile !== undefined && timeline.imageFile !== null
                ? timeline.imageFile
                : new File([""], "empty")
        );
        // documentFile
        if (timeline.documentFile.length > 0) {
            timeline.documentFile.map((row) => params.append("documentFile", row));
        } else {
            params.append("documentFile", new File([""], "empty"));
        }

        // documentName
        if (timeline.documentName.length > 0) {
            let sendDocumetName = "";
            timeline.documentName.map((row) => {
                if (sendDocumetName !== "") {
                    sendDocumetName = sendDocumetName + "," + row;
                } else {
                    sendDocumetName = row;
                }
                return null;
            });

            params.append(
                "documentName",
                new Blob([sendDocumetName], {
                    type: "application/json",
                })
            );
        } else {
            params.append(
                "documentName",
                new Blob([JSON.stringify("")], {
                    type: "application/json",
                })
            );
        }
        params.append(
            "timeLineInfo",
            new Blob([JSON.stringify(timeline.timeLineInfo)], {
                type: "application/json",
            })
        );
        return getAxiosInstance()
            .post("/api/uploadTimeline", params, {
                headers: { "content-type": "multipart/form-data" },
            })
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },

    // タイムラインアップロードキャンセル
    UpdateTimelineStatus(status: string, id: number): Promise<any> {
        return getAxiosInstance()
            .post("/api/updateTimelineStatus", { status: status, id: id })
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },

    // 直近のフッテージ取得
    getRecentFootages(userId: number, days: number): Promise<any> {
        return getAxiosInstance()
            .get("/api/getRecentFootages", { params: { userId: userId, days: days } })
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },

    // タイムライン作成
    createTimeline(userId: number, timelineName: string): Promise<any> {
        return getAxiosInstance()
            .post("/api/createTimeline", { userId: userId, name: timelineName })
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },

    // タイムライン削除
    deleteTimeline(userId: number, timelineId: number): Promise<any> {
        return getAxiosInstance()
            .post("/api/deleteTimeline", { userId: userId, id: timelineId })
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },

    //タイムライン取得
    getTimeline(id: number): Promise<Timeline> {
        return getAxiosInstance()
            .get("/api/getTimeline", {
                params: {
                    id: id,
                },
            })
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },

    //フッテージリストを取得
    getFootageList(id: number): Promise<Footage[]> {
        return getAxiosInstance()
            .get("/api/getFootages", {
                params: { id: id },
            })
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },

    //フッテージ動画取得
    getFootageVideo(id: number): Promise<any> {
        return getAxiosInstance()
            .get("/api/getFootageVideo", {
                params: { id: id },
            })
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },

    //サムネイル取得
    getThumbnail(id: number): Promise<string> {
        return getAxiosInstance()
            .get("/api/getThumbnail", {
                params: { id: id },
            })
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },

    //利用可能ディレクトリリスト取得
    getUsableDirList(id: number): Promise<Folder[]> {
        return getAxiosInstance()
            .get("/api/getUsableDir", {
                params: { id: id },
            })
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },

    // クリップ追加
    createClip(
        timelineId: number,
        footageId: number,
        start: number,
        end: number,
        seq: number,
        userId: number
    ): Promise<any> {
        return getAxiosInstance()
            .post("/api/addClip", {
                id: timelineId,
                footageId: footageId,
                start: start,
                end: end,
                seq: seq,
                userId: userId,
            })
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },

    // クリップ移動
    moveClip(id: number, seq: number, userId: number): Promise<any> {
        return getAxiosInstance()
            .post("/api/moveClip", {
                id: id,
                seq: seq,
                userId: userId,
            })
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },
    // クリップを削除
    deleteClip(id: number, userId: number): Promise<any> {
        return getAxiosInstance()
            .post("/api/deleteClip", {
                id: id,
                userId: userId,
            })
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },
    //クリップの分割
    cutClip(id: number, cutPoint: number, userId: number): Promise<any> {
        return getAxiosInstance()
            .post("/api/cutClip", {
                id: id,
                cutPoint: cutPoint,
                userId: userId,
            })
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },

    // タイライム名変更
    renameTimeline(id: number, name: string, userId: number): Promise<any> {
        return getAxiosInstance()
            .post("/api/renameTimeline", { id: id, newName: name, userId: userId })
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },

    // タイムライン編集のUNDO、REDO
    updateTimelineClipList(timelineId: number, userId: number, clipList: Clip[]): Promise<any> {
        return getAxiosInstance()
            .post("/api/updateTimelineClipList", { timelineId, userId, clipList })
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },
};
